/**
 *
 * @module loggingApi
 *
 */

// import Check from 'check-types';
import Logging from './../logging/entry';

/**
 *
 * @class LoggingApi
 * @desc Manages information that is used for logging purposes.
 *
 */
export default class LoggingApi {

    /**
     *
     * @param {SDK.Logging.Logger} [logger=Logging]
     *
     */
    constructor(logger = Logging) {

        /**
         *
         * @access private
         * @type {SDK.Logging.Logger}
         *
         */
        this.logger = logger;

        this.logger.info('LoggingApi', 'Created.');

    }

    /**
     *
     * @access public
     * @param {String} id - The tracking ID that should be registered.
     * @param {String} forProvider - The provider that is tracking the ID.
     * @desc Registers an ID for third party tracking.
     * @returns {Promise<Void>}
     *
     */
    registerCorrelationId(id, forProvider) { // eslint-disable-line

        // const method = 'LoggingApi.registerCorrelationId(id, forProvider)';
        // const idError = `${method} id should be a String with length`;
        // const forProviderError = `${method} forProvider should be a String with length`;

        // Check.assert.nonEmptyString(id, idError, InvalidArgumentException);
        // Check.assert.nonEmptyString(forProvider, forProviderError, InvalidArgumentException);

        return new Promise((resolve, reject) => {
            return reject(new Error('Not Implemented'));
        });

    }

    /**
     *
     * @access public
     * @param {String} forProvider - The provider that is tracking the ID.
     * @desc Unregisters an ID for third party tracking.
     * @returns {Promise<Void>}
     *
     */
    deregisterCorrelationId(forProvider) { // eslint-disable-line

        // const method = 'LoggingApi.deregisterCorrelationId(forProvider)';
        // const forProviderError = `${method} forProvider should be a String with length`;

        // Check.assert.nonEmptyString(forProvider, forProviderError, InvalidArgumentException);

        return new Promise((resolve, reject) => {
            return reject(new Error('Not Implemented'));
        });

    }

    /**
     *
     * @access private
     * @desc All currently registered third party tracking identifiers
     * @returns {Promise<Object>}
     *
     */
    correlationIds() {

        return new Promise((resolve, reject) => {
            return reject(new Error('Not Implemented'));
        });

    }

}



// WEBPACK FOOTER //
// ./src/logging/loggingApi.js